import { render, staticRenderFns } from "./ApuracaoAcaoSemFluxoValidacoes.vue?vue&type=template&id=470282fc&"
import script from "./ApuracaoAcaoSemFluxoValidacoes.vue?vue&type=script&lang=js&"
export * from "./ApuracaoAcaoSemFluxoValidacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports